"use strict";
exports.__esModule = true;
exports.EMBED_RELINK_ACCEPT_OFFER_DETAILS = void 0;
exports.EMBED_RELINK_ACCEPT_OFFER_DETAILS = {
    HEADER: 'Your schedule is ready!',
    BODY: 'Finalize your schedule. Note that you can always make changes to your 2nd payment date later.',
    AUTHORIZATION: 'I authorize Flex to charge my card according to this payment schedule. I acknowledge that payment amounts are estimates and may vary.'
};
